export default {
    ttl: {
        pageTitle: 'Note (runtime)| Trial account',
        title: 'Your free trial account has expired.',
        intro: 'Contact us and secure all the benefits with your Trendmanager access:',
        feature1: 'Comprehensive trend database: access to 18 mega-trends, 139 macro-trends and over 50,000 micro-trends.',
        feature2: 'Efficient trend scouting: Save time identifying relevant trends.',
        feature3: 'Trend radar creation: Visualize and evaluate trends individually.',
        feature4: 'Collaborative working: Share insights and work on future strategies as a team.',
        outro: 'Get your personal quote for the Trendmanager now or arrange a demo to clarify any open questions.',
        action: {
            getQuote: 'Request offer',
            makeAppointment: {
                label: 'Arrange demo',
                url: 'https://outlook.office365.com/book/TRENDONEEnglsich@trendone.com/s/qgLLuIBxYE6Sz1zoBJ20CQ2'
            }
        }
    },
    optIn: {
        pageTitle: 'Note (opt-in)| Freemium',
        content1: 'This link is no longer current.',
        content2: 'You have already activated your trial account. <a class="on-blue" href="/password-reset/request">Here</a> you can log in to your trendmanager account or reset your password if you have forgotten your old one.'
    }
}
